<template>
    <div>
      <common-dialog
        ref="dialog"
        width="700px"
        :show-save-button="$permission.canEdit()"
        unit="商品品牌"
        edit-title
        id-key="RecordId"
        :data="data"
        form-label-width="95px"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        close-on-saved
        :before-save="onBeforeSave"
        :get-data-func="api.info"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="品牌名称" prop="BrandName">
                <el-input v-model="data.BrandName" placeholder="请填写品牌名称" clearable></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="isMB ? 24 : 12">
            
            <el-form-item label="品牌国家" prop="CountryId">
              <el-select v-model="data.CountryId" placeholder="请选择品牌国家" clearable>
                  <el-option v-for="(i, k) in Countrys" :key="k" :label="i.CountryCode+i.CountryName" :value="i.RecordId"></el-option>
              </el-select>
            </el-form-item>
          </el-col> 
          

            
        </el-row>
                                             


          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import singlePicUpload from "@/components/common/photo/singleUpload";
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      singlePicUpload
    },
    data() {
      return {
        data: {
          RecordId: 0,
         
          BrandName: "",
           CountryId: null,
         
          OrderId: 0,
          State: 1,
          },
       
        api: require("@/api/goods/brandplatform").default,
         country_api:require("@/api/sy/country").default,
        isMB: this.$store.state.isMB,
        rules: {
            BrandName: [{ required: true, message: "品牌名称不能为空" }],
           CountryId: [{ required: true, message: "品牌国家不能为空" }],
          OrderId: [{ required: true, message: "序号不能为空" }],
        },
        uploadUrl: "/api/Common/UploadPicture",
         Countrys: [],
      };
    },
  mounted() {
   
    this.country_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Countrys = res.Data;
      }
    })
   
  },
    methods: {
      onCreateOpened(row) {
             
        this.api.getMaxOrderId().then(res => {
          if(res.Code==0) this.data.OrderId = res.Data;
        })
      },
      onEditOpened(row) {
        
    },
    onBeforeSave() {
      
    },
    onClosed() {

    },
    },
  };
  </script>